import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()

/**
 * scrollIntoViewのPolyfillのラッパー
 */

export default (element, option) => {
  if (!element || !(element instanceof HTMLElement) || !element.clientHeight) return

  const defaultOption = {
    behavior: 'smooth',
    block: 'start',
    inline: 'nearest',
  }

  element.scrollIntoView(option || defaultOption)
}
